import store from '../store/redux.store'
import rolesEnum from "@/constant/rolesEnum";

const roleActive = () => { 
    const role = store.getState().profile.profile.role;

    const adminActive = () => {
        if(role == rolesEnum.admin || role == rolesEnum.juniorAdmin) {
            return true;
        }
        return false;
    }

    const rolesActive = {
        admin: role == rolesEnum.admin,
        juniorAdmin: role == rolesEnum.juniorAdmin,
        adminPanel: role == rolesEnum.adminPanel,
        children: role == rolesEnum.children,
        parent: role == rolesEnum.parent,
        hrManager: role == rolesEnum.hrManager,
        htPanel: role == rolesEnum.htPanel,
        personalManager: role == rolesEnum.personalManager,
        seminarian: role == rolesEnum.seminarian,
        seniorSeminarian: role == rolesEnum.seniorSeminarian,
        adminOrjuniorAdmin: adminActive(),
        childrenOrParent: role == rolesEnum.children || role == rolesEnum.parent
    }

    return { adminActive, rolesActive }; 
};
export default roleActive;